// Roles
export const ROLE_FULL_ADMINISTRATOR = "b8c2b209-79f5-4ccd-9a52-2af514a8ec65";
export const ROLE_READ_ONLY_ADMINISTRATOR = "4b46122a-fd48-41ca-a485-09a1a2f19329";

export const SERVICE_ROLES = [ ROLE_FULL_ADMINISTRATOR, ROLE_READ_ONLY_ADMINISTRATOR ];